<template>
    <all-campaigns-base
        companyTypeFilter="all"
        :initialCategory="initialCategory"
        :initialSubcategory="initialSubcategory"
        :initialTitle="initialTitle"
        :initialMetaDesc="initialMetaDesc"
        :data="data"
        :paginator="paginator">
        <template #heading>
            <expandable-text :max-length="100" :disabled="!$isMobile">
               Här serverar vi ett sammelsurium av det mesta du kan tänka dig! Och det finfina är att du lätt som en plätt sorterar dig fram till det du söker. Använd “Sökfunktionen”, välj bland kategorier och underkategorier, eller så visar du helt enkelt de senast inkomna rabatterna. Mycket nöje!
            </expandable-text>
        </template>
    </all-campaigns-base>
</template>

<script>
    import AllCampaignsBase from '@/Pages/AllCampaigns/AllCampaigns';

    export default {
        inject: ['$isMobile'],

        props: ['initialCategory', 'initialSubcategory', 'initialTitle', 'initialMetaDesc', 'data', 'paginator'],

        components: { AllCampaignsBase },
    }
</script>
